import {
  bulkUploadNews,
  bulkUploadNewsTranslations,
  downloadNewsBulkUploadTemplate,
  downloadNewsTranslationsBulkUploadTemplate,
} from "../../../../services/cms/cms";
import BulkUploadSection from "../../../../components/bulk_upload/bulk_upload_section";
import BulkUploadDialogShell from "../../../../components/bulk_upload/bulk_upload_dialog_shell";

interface BulkUploadNewsDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function BulkUploadNewsDialog({
  open,
  onClose,
}: BulkUploadNewsDialogProps) {
  return (
    <BulkUploadDialogShell
      open={open}
      onClose={onClose}
      title="Bulk Upload News"
      createTabLabel="Create News"
      translationsTabLabel="Add Translations"
      createTabContent={
        <BulkUploadSection
          description="Upload an .xlsx file to create many news articles at once, in English. Download the template first for the exact column format and the valid News Channel names. The featured image must already be uploaded via the News form's image picker - paste its URL into the sheet."
          templateFileName="news_bulk_upload_template.xlsx"
          onDownloadTemplate={downloadNewsBulkUploadTemplate}
          onUpload={bulkUploadNews}
          savedLabel="created"
          listQueryKey="cms-news"
        />
      }
      translationsTabContent={
        <BulkUploadSection
          description="Upload an .xlsx file to add translations to existing news articles - one row per News ID + language. Find a news article's ID on the News list or its details page."
          templateFileName="news_translations_bulk_upload_template.xlsx"
          onDownloadTemplate={downloadNewsTranslationsBulkUploadTemplate}
          onUpload={bulkUploadNewsTranslations}
          savedLabel="saved"
          listQueryKey="cms-news"
        />
      }
    />
  );
}
